import * as React from 'react';
import {Platform} from 'react-native';
import {useSelector} from 'react-redux';
import {isInternetReachableSelector} from '../../../redux/selectors/httpWrapper/netInfo';
import {DeviceSize, useDeviceSize} from '../../theme/helpers';
import {useModal} from '../modal';
import DesktopView from './desktop/view';
import MobileView from './mobile/view';

export const NoInternetNotification = () => {
  const deviceSize = useDeviceSize();
  const modal = useModal();
  const desktopModalId = React.useRef<string | null>(null);
  const isInternetReachable = useSelector(isInternetReachableSelector());

  React.useEffect(() => {
    if (Platform.OS === 'web' && deviceSize === DeviceSize.desktop) {
      if (isInternetReachable === false) {
        if (!desktopModalId.current) {
          modal.show({
            mobile: false,
            allowBodyScroll: true,
            render: ({id: modalId}) => {
              desktopModalId.current = modalId;
              return React.createElement(DesktopView, {});
            },
          });
        }
      } else {
        if (desktopModalId.current) {
          modal.remove(desktopModalId.current);
          desktopModalId.current = null;
        }
      }
    }
  }, [deviceSize, modal, isInternetReachable]);

  if (isInternetReachable || isInternetReachable === null) {
    return null;
  }

  switch (deviceSize) {
    case DeviceSize.mobile:
    case DeviceSize.tablet:
      return <MobileView />;
    default:
      return null;
  }
};
